import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const LC_REBOOT = gql`
mutation Reboot($domain: String!, $lanControllerId: Int!) {
	controller {
		reboot(domain: $domain, lanControllerId: $lanControllerId) {
			code
			success
			message
		}
	}
}
`

export interface LCRebootResponse {
	controller: {
		reboot: Def_MutationResponse | null
	}
}

export interface LCRebootArgs {
	domain: string;
	lanControllerId: number;
}

